/**
 * Tag Service
 * Handles tag search API calls
 * Note: Tag creation/removal is handled by existing entity APIs (rituals, communities, profiles)
 */

import { PAGINATION } from "@/constants/constants"
import { apiClient } from "@/lib/api-client"
import type { SearchTagsParams, TagSearchResponse } from "../types/tag.types"

/**
 * Search tags by query with pagination
 *
 * @param params - Search parameters including query, page, limit, and excludeIds
 * @returns Search results with tags and pagination info
 */
export async function searchTags(params: SearchTagsParams): Promise<TagSearchResponse> {
  const { query, page, limit = PAGINATION.DEFAULT_LIMIT, excludeIds } = params

  const queryParams = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
  })

  if (query && query.trim().length > 0) {
    queryParams.append("q", query.trim())
  }

  if (excludeIds && excludeIds.length > 0) {
    queryParams.append("excludeIds", excludeIds.join(","))
  }

  const response = await apiClient.get<TagSearchResponse>(
    `/api/tags/search?${queryParams.toString()}`,
  )

  return response.data
}
